import React from "react";

export const LettingIdContext = React.createContext({} as { lettingId?: number; onAdd?: () => void });
